import { render, staticRenderFns } from "./PopupLayer.vue?vue&type=template&id=0363eabf&scoped=true&"
import script from "./PopupLayer.vue?vue&type=script&lang=ts&"
export * from "./PopupLayer.vue?vue&type=script&lang=ts&"
import style0 from "./PopupLayer.vue?vue&type=style&index=0&id=0363eabf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0363eabf",
  null
  
)

export default component.exports